// Fetch timesheet metadata
export const FETCH_TIMESHEET_MODE_REQUEST = 'FETCH_TIMESHEET_MODE_REQUEST';
export const FETCH_TIMESHEET_MODE_SUCCESS = 'FETCH_TIMESHEET_MODE_SUCCESS';
export const FETCH_TIMESHEET_MODE_FAILURE = 'FETCH_TIMESHEET_MODE_FAILURE';

export const FETCH_TIMESHEET_PROJECT_REQUEST = 'FETCH_TIMESHEET_PROJECT_REQUEST';
export const FETCH_TIMESHEET_PROJECT_SUCCESS = 'FETCH_TIMESHEET_PROJECT_SUCCESS';
export const FETCH_TIMESHEET_PROJECT_FAILURE = 'FETCH_TIMESHEET_PROJECT_FAILURE';

export const FETCH_TIMESHEET_MODULE_REQUEST = 'FETCH_TIMESHEET_MODULE_REQUEST';
export const FETCH_TIMESHEET_MODULE_SUCCESS = 'FETCH_TIMESHEET_MODULE_SUCCESS';
export const FETCH_TIMESHEET_MODULE_FAILURE = 'FETCH_TIMESHEET_MODULE_FAILURE';

export const FETCH_TIMESHEET_TASK_REQUEST = 'FETCH_TIMESHEET_TASK_REQUEST';
export const FETCH_TIMESHEET_TASK_SUCCESS = 'FETCH_TIMESHEET_TASK_SUCCESS';
export const FETCH_TIMESHEET_TASK_FAILURE = 'FETCH_TIMESHEET_TASK_FAILURE';

export const FETCH_TIMESHEET_TASKTYPE_REQUEST = 'FETCH_TIMESHEET_TASKTYPE_REQUEST';
export const FETCH_TIMESHEET_TASKTYPE_SUCCESS = 'FETCH_TIMESHEET_TASKTYPE_SUCCESS';
export const FETCH_TIMESHEET_TASKTYPE_FAILURE = 'FETCH_TIMESHEET_TASKTYPE_FAILURE';

export const FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_REQUEST = 'FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_REQUEST';
export const FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_SUCCESS = 'FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_SUCCESS';
export const FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_FAILURE = 'FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_FAILURE';

export const FETCH_TIMESHEET_LIST_REQUEST = 'FETCH_TIMESHEET_LIST_REQUEST';
export const FETCH_TIMESHEET_LIST_SUCCESS = 'FETCH_TIMESHEET_LIST_SUCCESS';
export const FETCH_TIMESHEET_LIST_FAILURE = 'FETCH_TIMESHEET_LIST_FAILURE';

export const FETCH_TIMESHEET_MONTH_DETAILS_REQUEST = 'FETCH_TIMESHEET_MONTH_DETAILS_REQUEST';
export const FETCH_TIMESHEET_MONTH_DETAILS_SUCCESS = 'FETCH_TIMESHEET_MONTH_DETAILS_SUCCESS';
export const FETCH_TIMESHEET_MONTH_DETAILS_FAILURE = 'FETCH_TIMESHEET_MONTH_DETAILS_FAILURE';

export const SAVE_TIMESHEET_DETAILS_REQUEST = 'SAVE_TIMESHEET_DETAILS_REQUEST';
export const SAVE_TIMESHEET_DETAILS_SUCCESS = 'SAVE_TIMESHEET_DETAILS_SUCCESS';
export const SAVE_TIMESHEET_DETAILS_FAILURE = 'SAVE_TIMESHEET_DETAILS_FAILURE';

export const CHANGE_TIMESHEET_TASK_STATUS_REQUEST = 'CHANGE_TIMESHEET_TASK_STATUS_REQUEST';
export const CHANGE_TIMESHEET_TASK_STATUS_SUCCESS = 'CHANGE_TIMESHEET_TASK_STATUS_SUCCESS';
export const CHANGE_TIMESHEET_TASK_STATUS_FAILURE = 'CHANGE_TIMESHEET_TASK_STATUS_FAILURE';

export const FETCH_TIMESHEET_CLIENT_REQUEST = 'FETCH_TIMESHEET_CLIENT_REQUEST';
export const FETCH_TIMESHEET_CLIENT_SUCCESS = 'FETCH_TIMESHEET_CLIENT_SUCCESS';
export const FETCH_TIMESHEET_CLIENT_FAILURE = 'FETCH_TIMESHEET_CLIENT_FAILURE';

